var map = {
	"./circle-small.svg": 92445,
	"./circle.svg": 49119,
	"./ellipse-small.svg": 27805,
	"./ellipse.svg": 4415,
	"./hidden.png": 85847,
	"./hiddenBeforeCompress.png": 7962,
	"./inverted-triangle-small.svg": 9047,
	"./inverted-triangle.svg": 45973,
	"./rectangle-small.svg": 89284,
	"./rectangle.svg": 37534,
	"./rhombus-small.svg": 53739,
	"./rhombus.svg": 16985,
	"./square-small.svg": 24116,
	"./square.svg": 63022,
	"./triangle-small.svg": 76369,
	"./triangle.svg": 35651
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 67755;